import { TranslateService } from '@ngx-translate/core';
import { InstitutionPermissionState } from 'src/app/models/user';

export interface UserSettingsPermissionsSelection {
  value: InstitutionPermissionState;
  title: string;
  description?: string;
}

export class UserSettingsPermissionsSelections {
  get DEFAULT_ON_SELECTION(): UserSettingsPermissionsSelection {
    return {
      value: InstitutionPermissionState.DEFAULT_ON,
      title: this.translateService.instant('Default On (Hosts Can Modify)'),
    };
  }

  get DEFAULT_OFF_SELECTION(): UserSettingsPermissionsSelection {
    return {
      value: InstitutionPermissionState.DEFAULT_OFF,
      title: this.translateService.instant('Default Off (Hosts Can Modify)'),
    };
  }

  get ALWAYS_OFF_SELECTION(): UserSettingsPermissionsSelection {
    return {
      value: InstitutionPermissionState.ALWAYS_OFF,
      title: this.translateService.instant('Always Off (Hosts Cannot Modify)'),
    };
  }

  get ALWAYS_ON_SELECTION(): UserSettingsPermissionsSelection {
    return {
      value: InstitutionPermissionState.ALWAYS_ON,
      title: this.translateService.instant('Always On (Hosts Cannot Modify)'),
    };
  }

  private selections: UserSettingsPermissionsSelection[] = [];
  constructor(private translateService: TranslateService) {}

  public setDefaultSelections(): UserSettingsPermissionsSelections {
    this.selections = [
      this.DEFAULT_ON_SELECTION,
      this.DEFAULT_OFF_SELECTION,
      this.ALWAYS_OFF_SELECTION,
      this.ALWAYS_ON_SELECTION,
    ];

    return this;
  }

  public setSelections(
    customSelections: UserSettingsPermissionsSelection[],
  ): UserSettingsPermissionsSelections {
    this.selections = customSelections;

    return this;
  }

  public setDescriptions(descriptions: string[]): UserSettingsPermissionsSelections {
    let ind: number = 0;
    this.selections.forEach((selection) => {
      selection.description = descriptions[ind] ?? '';
      ind++;
    });

    return this;
  }

  public build(): UserSettingsPermissionsSelection[] {
    return this.selections;
  }
}
